import React from 'react';
import { Block } from '@mui/icons-material';
import selfie1 from "../img/selfie/selfie1.png";
import selfie2 from "../img/selfie/selfie2.png";
import selfie3 from "../img/selfie/selfie3.png";
import selfie4 from "../img/selfie/selfie4.png";
import selfie5 from "../img/selfie/selfie5.png";
import selfie6 from "../img/selfie/selfie6.png";
import selfie7 from "../img/selfie/selfie7.png";

const Selfie = ({ onImageClick }) => {
  return (
    <>
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <Block />
          <h3 className="help-center__examples-title">Selfie issues and mistakes to avoid</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--selfie">
            {/* Top row - 3 images */}
            <div className="help-center__example-images--selfie-row--3">
              <div className="help-center__image-placeholder help-center__image-placeholder--dont">
                <div className="help-center__image-label">Don't</div>
                <div className="help-center__image-box">
                  <img src={selfie1} alt="Selfie mistake 1" onClick={() => onImageClick && onImageClick(selfie1)} style={{cursor: 'pointer'}} />
                </div>
                <div className="help-center__image-caption">
                  Unrealistic selfie
                </div>
              </div>
              
              <div className="help-center__image-placeholder help-center__image-placeholder--dont">
                <div className="help-center__image-label">Don't</div>
                <div className="help-center__image-box">
                  <img src={selfie2} alt="Selfie mistake 2" onClick={() => onImageClick && onImageClick(selfie2)} style={{cursor: 'pointer'}} />
                </div>
                <div className="help-center__image-caption">
                  Hand coming out of nowhere
                </div>
              </div>
              
              <div className="help-center__image-placeholder help-center__image-placeholder--dont">
                <div className="help-center__image-label">Don't</div>
                <div className="help-center__image-box">
                  <img src={selfie7} alt="Selfie mistake 7" onClick={() => onImageClick && onImageClick(selfie7)} style={{cursor: 'pointer'}} />
                </div>
                <div className="help-center__image-caption">
                  Hand coming out of nowhere
                </div>
              </div>
           
              
          
            </div>
            
            {/* Bottom row - 3 images */}
            <div className="help-center__example-images--selfie-row--3">
              <div className="help-center__image-placeholder help-center__image-placeholder--dont">
                <div className="help-center__image-label">Don't</div>
                <div className="help-center__image-box">
                  <img src={selfie5} alt="Selfie mistake 5" onClick={() => onImageClick && onImageClick(selfie5)} style={{cursor: 'pointer'}} />
                </div>
                <div className="help-center__image-caption">
                  Hand is not doing a selfie
                </div>
              </div>
              
              <div className="help-center__image-placeholder help-center__image-placeholder--dont">
                <div className="help-center__image-label">Don't</div>
                <div className="help-center__image-box">
                  <img src={selfie6} alt="Selfie mistake 6" onClick={() => onImageClick && onImageClick(selfie6)} style={{cursor: 'pointer'}} />
                </div>
                <div className="help-center__image-caption">
                  Her hand look weird
                </div>
              </div>
              
              <div className="help-center__image-placeholder help-center__image-placeholder--dont">
                <div className="help-center__image-label">Don't</div>
                <div className="help-center__image-box">
                  <img src={selfie3} alt="Selfie mistake 3" onClick={() => onImageClick && onImageClick(selfie3)} style={{cursor: 'pointer'}} />
                </div>
                <div className="help-center__image-caption">
                  Cannot take selfie with 1. her hand 2. her phone
                </div>
              </div>
            </div>
          </div>
          
        
        </div>
      </div>
    </>
  );
};

export default Selfie;